export default __webpack_public_path__ + "static/media/proa.61c87a49.jpg";